__turbopack_context__.v({
  "favoriteAction": "_7-kgpG_favoriteAction",
  "favoriteButton": "_7-kgpG_favoriteButton",
  "favoriteShortcut": "_7-kgpG_favoriteShortcut",
  "search": "_7-kgpG_search",
  "star": "_7-kgpG_star",
});
